import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var TableUtils = /*#__PURE__*/function () {
  function TableUtils() {
    _classCallCheck(this, TableUtils);
  }
  _createClass(TableUtils, null, [{
    key: "createTableColumnOptions",
    value: function createTableColumnOptions(columnMetadata, driver) {
      return {
        name: columnMetadata.databaseName,
        length: driver.getColumnLength(columnMetadata),
        width: columnMetadata.width,
        charset: columnMetadata.charset,
        collation: columnMetadata.collation,
        precision: columnMetadata.precision,
        scale: columnMetadata.scale,
        zerofill: columnMetadata.zerofill,
        unsigned: columnMetadata.unsigned,
        asExpression: columnMetadata.asExpression,
        generatedType: columnMetadata.generatedType,
        default: driver.normalizeDefault(columnMetadata),
        onUpdate: columnMetadata.onUpdate,
        comment: columnMetadata.comment,
        isGenerated: columnMetadata.isGenerated,
        generationStrategy: columnMetadata.generationStrategy,
        generatedIdentity: columnMetadata.generatedIdentity,
        isNullable: columnMetadata.isNullable,
        type: driver.normalizeType(columnMetadata),
        isPrimary: columnMetadata.isPrimary,
        isUnique: driver.normalizeIsUnique(columnMetadata),
        isArray: columnMetadata.isArray || false,
        enum: columnMetadata.enum ? columnMetadata.enum.map(function (val) {
          return val + "";
        }) : columnMetadata.enum,
        enumName: columnMetadata.enumName,
        primaryKeyConstraintName: columnMetadata.primaryKeyConstraintName,
        spatialFeatureType: columnMetadata.spatialFeatureType,
        srid: columnMetadata.srid
      };
    }
  }]);
  return TableUtils;
}();